import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { Provider } from "react-redux";
import store from "./redux/store";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./tanstack queries/queryClient";

// posthog.init("phc_4VGE8i8CawDWQIjqNWHE0P2Zqmg3QyJGvhhBExU1I6b", {
//   api_host: "https://us.i.posthog.com",
//   capture_pageview: false,
//   disable_session_recording: false,
// });

// posthog.startSessionRecording({ sampling: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <PostHogProvider client={posthog}>
  <Router>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <App />
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  </Router>
  // </PostHogProvider>
);
